import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  addFeeButtonSectionHeader: {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
    ':active': {
      backgroundColor: theme.palette.neutralLight,
    },
  },
  addFeeButtonSectionHeaderDisabled: {
    backgroundColor: theme.palette.neutralLighter,
    ':hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
    ':active': {
      backgroundColor: theme.palette.neutralLighter,
    },
    cursor: 'default',
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  addRoyaltyFeeHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
  addRoyaltyFeeHeader: {
    justifyContent: 'flex-start',
  },
  addRoyaltyFeeExitButton: {
    justifyContent: 'flex-end',
  },
  cancelButton: {
    marginRight: '1rem',
    fontWeight: 400,
  },
  royaltyFeeIcon: {
    fontSize: pxToRem(16),
    color: theme.palette.themePrimary,
  },
  spinner: {
    marginTop: pxToRem(40),
  },
  errorText: {
    color: theme.palette.accentError,
  },
  cardSection: {
    marginBottom: pxToRem(16),
  },
});
